import { render } from "./LandingFinancial.vue?vue&type=template&id=1b963e3c"
import script from "./LandingFinancial.vue?vue&type=script&lang=js"
export * from "./LandingFinancial.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__